module.exports = __webpack_public_path__ + "media/images/emblems/Schwarzenberg_LU-e7ae7e2566a999409df34039e76cba41.png";